<template lang="html">
  <div class="NewApply">
    <div class="applybox">
      <div class="app_apply_content">
        <p class="app_apply_txt">
          填写报名信息
        </p>
        <div class="app_apply_name inputbox">
          <p> 姓名 </p>
          <input type="text" name="" value="" placeholder="请输入您的姓名" v-model='appName'>
        </div>
        <div class="app_apply_phone inputbox">
          <p> 手机 </p>
          <input type="text" name="" value="" placeholder="请输入您的手机号" v-model='appPhone'>
        </div>
        <div class="app_apply_code">
          <input type="text" name="" value="" placeholder="请输入验证码" v-model="sms_code">
          <div type="button" name="button" @click="cellPhone()"> {{content}} </div>
        </div>
        <div class="app_apply_email inputbox">
          <p> 邮箱 </p>
          <input type="text" name="" value="" placeholder="请输入您的邮箱" v-model='appEmail'>
        </div>
        <div class="app_apply_school inputbox">
          <p> 学校 </p>
          <input type="text" name="" value="" placeholder="请输入您的学校" v-model='appSchool'>
        </div>
        <div class="inputbox">
          <p>所学专业</p>
          <select v-model="appPosition">
            <option value="" disabled selected>请选择</option>
            <option value="计算机相关">A.计算机相关</option>
            <option value="电子工程相关">B.电子工程相关</option>
            <option value="自动控制相关">C.自动控制相关</option>
            <option value="其他">D.其他</option>
          </select>
        </div>
        <div class="inputbox">
          <p>了解FPGA技术的主要途径</p>
          <select v-model="appFpga">
            <option value="" disabled selected>请选择</option>
            <option value="学校专业课程">A.学校专业课程</option>
            <option value="技术论坛自学">B.技术论坛自学</option>
            <option value="尚未开始了解">C.尚未开始了解</option>
            <option value="其他">D.其他</option>
          </select>
        </div>
        <div class="inputbox">
          <p>是否听过赛灵思Vitis/Vitis AI软件平台？</p>
          <select v-model="appXilinx">
            <option value="" disabled selected>请选择</option>
            <option value="具有使用经验">A.具有使用经验</option>
            <option value="大致了解用途">B.大致了解用途</option>
            <option value="仅听说过">C.仅听说过</option>
            <option value="从未听说">D.从未听说</option>
          </select>
        </div>
        <div class="btnbox">
          <div class="btn_sure" @click="sureinfos()">
            确定
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utils from '@/utils/utils.js';

  export default {
    data() {
      return {
        appName: '',
        appPhone: '',
        appEmail: '',
        appSchool: '',
        sms_code: '',
        totalTime: 60,
        content: '发送验证码',
        appPosition: '',
        appFpga: '',
        appXilinx: ''
      }
    },
    components: {
      
    },
    methods: {
      /* 获取验证码 */
      cellPhone() {
        if (this.appPhone == '') {
          utils.showMessage('手机号输入有误')
        } else {
          this.$http({
            url: '/Registered/getPhoneSmsCode',
            method: 'get',
            params: utils.cso({
              phone: this.appPhone,
              phone_head: 86,
              type: 4,
              client: 'H5'
            })
          }).then((res) => {
            if (res.code == 0) {
              this.content = this.totalTime + 's后重新发送'
              let clock = window.setInterval(() => {
                this.totalTime--
                this.content = this.totalTime + 's后重新发送'
                if (this.totalTime < 0) {
                  window.clearInterval(clock)
                  this.content = '发送验证码'
                  this.totalTime = 60
                }
              }, 1000)
            } else {
              utils.showMessage(res.msg);
            }
          })
        }
      },

      /* 发送请求 */
      sureinfos() {
        if (this.appName != '') {
          if (/^1[3|4|5|6|7|8|9]\d{9}$/.test(this.appPhone)) {
            if (this.sms_code != '') {
              if (/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.appEmail)) {
                if (this.appSchool != '') {
                  if (this.appPosition != '') {
                    if (this.appFpga != '') {
                      if (this.appXilinx != '') {
                        this.$http({
                          url: '/activity/activityRegister',
                          method: 'post',
                          params: {
                            activity_id: 340,
                            name: this.appName,
                            phone: this.appPhone,
                            sms_code: this.sms_code,
                            email: this.appEmail,
                            company: this.appSchool,
                            position: this.appPosition,
                            pathway: this.appFpga,
                            heard: this.appXilinx
                          }
                        }).then((res) => {
                          if (res.code == '0') {
                            this.$router.push({
                              path: '/AMDXilinxSucceed'
                            })
                          } else {
                            utils.showMessage(res.msg)
                          }
                        })
                      } else {
                        utils.showMessage('请选择是否听过赛灵思Vitis/Vitis AI软件平台')
                      }
                    } else {
                      utils.showMessage('请选择了解FPGA技术的主要途径')
                    }
                  } else {
                    utils.showMessage('请选择所学专业')
                  }
                } else {
                  utils.showMessage('请输入学校名称')
                }
              } else {
                utils.showMessage('请输入正确的邮箱')
              }
            } else {
              utils.showMessage('请输入验证码')
            }
          } else {
            utils.showMessage('请输入正确的手机号')
          }
        } else {
          utils.showMessage('请输入姓名')
        }
      },
    }
  }
</script>

<style lang="css" scoped>
  .applybox {
    box-sizing: border-box;
  }

  .app_apply_content {
    padding: 0 15px 30px 15px;
  }

  .app_apply_txt {
    color: #555;
    font-size: 18px;
    margin-top: 14px;
    margin-bottom: 15px;
    text-align: center;
    font-weight: 600;
  }

  .inputbox {
    box-sizing: border-box;
    padding: 10px 0;
    border-bottom: 1px solid #DEE7EC;
  }

  .inputbox select {
    border: 0;
    color: #333;
    font-size: 16px;
    width: 100%;
    outline: none;
    font-weight: 600;
    appearance: none;
    -moz-appearance: none;
    background: #ffffff;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
  }

  select option {
    background: #F6F7FB;
    color: #606972;
    outline: none
  }

  .inputbox select:focus {
    outline: none
  }

  .inputbox p {
    margin-bottom: 10px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 32px;
  }

  .inputbox input {
    box-sizing: border-box;
    border: none;
    height: 100%;
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    outline: none;
    color: #333;
  }

  .app_apply_code {
    padding: 5px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .app_apply_code input {
    box-sizing: border-box;
    border: none;
    outline: none;
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }

  input::-webkit-input-placeholder {
    font-size: 16px;
    line-height: 22px;
    color: #C9CCD8;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }

  input:-moz-placeholder {
    font-size: 16px;
    line-height: 22px;
    color: #C9CCD8;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }

  input::-moz-placeholder {
    font-size: 16px;
    line-height: 22px;
    color: #C9CCD8;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }

  input:-ms-input-placeholder {
    font-size: 16px;
    line-height: 22px;
    color: #C9CCD8;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }

  .app_apply_code div {
    line-height: 32px;
    font-size: 15px;
    color: #F7443F;
  }

  .btnbox {
    display: flex;
    justify-content: center;
    margin-top: 60px;
  }

  .btn_sure {
    width: 100%;
    text-align: center;
    height: 50px;
    line-height: 50px;
    color: #ffffff;
    font-size: 18px;
    background: linear-gradient(168deg, #F62A3E 0%, #E60001 100%);
    box-shadow: 0px 2px 4px 0px rgba(186, 12, 18, 0.17);
    border-radius: 27px;
  }
</style>
